var map = {
	"./emoji/emoji-0.png": 51687,
	"./emoji/emoji-1.png": 75902,
	"./emoji/emoji-2.png": 12629,
	"./emoji/emoji-3.png": 1004,
	"./emoji/emoji-4.png": 34051,
	"./emoji_2/emoji-0.png": 81136,
	"./emoji_2/emoji-1.png": 87385,
	"./emoji_2/emoji-2.png": 20802,
	"./emoji_2/emoji-3.png": 11307,
	"./emoji_2/emoji-4.png": 61396,
	"./emoji_3/emoji-0.png": 67861,
	"./emoji_3/emoji-1.png": 33855,
	"./emoji_3/emoji-2.png": 23271,
	"./emoji_3/emoji-3.png": 47486,
	"./emoji_3/emoji-4.png": 92049,
	"./emoji_4/emoji-0.png": 99074,
	"./emoji_4/emoji-1.png": 62731,
	"./emoji_4/emoji-2.png": 97328,
	"./emoji_4/emoji-3.png": 29433,
	"./emoji_4/emoji-4.png": 24454
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 18212;